<template>
  <a-menu
    v-model:openKeys="openKeys"
    v-model:selectedKeys="selectedKeys"
    :mode="mode"
    :theme="darkMode ? 'dark' : 'light'"
  >
    <span v-for="menu in menus" :key="menu">
      <a-menu-item v-if="menu.childs.length == 0" @click="toggleCollapsed" :key="menu.id">
        <router-link :to="{ name: menu.link_name }">
          <sdFeatherIcons :type="menu.icon || 'menu'" />
          <span> {{ menu.detail[$store.state.i18n.i_lang] }} </span>
        </router-link>
      </a-menu-item>

      <a-sub-menu v-if="menu.childs.length != 0" :key="menu.id">
        <template v-slot:title>
          <sdFeatherIcons :type="menu.icon || 'menu'" /><span>{{ menu.detail[$store.state.i18n.i_lang] }}</span>
        </template>
        <a-menu-item v-for="child in menu.childs" :key="child.link_name" @click="toggleCollapsed">
          <router-link :to="{ name: child.link_name }"> {{ child.detail[$store.state.i18n.i_lang] }} </router-link>
        </a-menu-item>
      </a-sub-menu>
    </span>
  </a-menu>
</template>
<script>
import { computed, reactive, ref, toRefs, watch, watchEffect } from 'vue';
import VueTypes from 'vue-types';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import versions from '../demoData/changelog.json';

export default {
  name: 'AsideItems',
  props: {
    toggleCollapsed: VueTypes.func,
    events: VueTypes.object,
  },
  data() {
    return {
      menus: [],
    };
  },
  methods: {
    decoder(value) {
      return atob(value);
    },
    getMenu() {
      this.$appAxios.get(this.$endpoints.menu_get).then((resp) => {
        this.menus = resp.data.data;
      });
    },
  },
  created() {
    this.getMenu();
  },
  setup(props) {
    const store = useStore();
    const darkMode = computed(() => store.state.themeLayout.data);
    const mode = ref('inline');
    const { events } = toRefs(props);
    const { onRtlChange, onLtrChange, modeChangeDark, modeChangeLight, modeChangeTopNav, modeChangeSideNav } =
      events.value;

    const router = computed(() => useRoute());
    const state = reactive({
      selectedKeys: ['home'],
      openKeys: ['dashboard'],
      preOpenKeys: ['dashboard'],
    });

    watchEffect(() => {
      if (router.value.matched.length) {
        if (router.value.matched.length > 2) {
          state.selectedKeys = [router.value.matched[2].name];
          state.openKeys = [router.value.matched[1].name];
          state.preOpenKeys = [router.value.matched[1].name];
        } else if (router.value.matched.length > 3) {
          state.selectedKeys = [router.value.matched[3].name];
          state.openKeys = [router.value.matched[1].name];
          state.preOpenKeys = [router.value.matched[1].name];
        } else {
          state.selectedKeys = [router.value.matched[1].name];
          state.openKeys = [router.value.matched[1].name];
          state.preOpenKeys = [router.value.matched[1].name];
        }
      }
    });

    watch(
      () => state.openKeys,
      (val, oldVal) => {
        state.preOpenKeys = oldVal;
      },
    );

    return {
      mode,
      ...toRefs(state),
      darkMode,
      onRtlChange,
      onLtrChange,
      modeChangeDark,
      modeChangeLight,
      modeChangeTopNav,
      modeChangeSideNav,
      versions,
    };
  },
};
</script>
